import List from "@material-ui/core/List";
import routes from "../../constants/routes";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined";

import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

//MATERIAL-UI
import Link from "@material-ui/core/Link";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import ImportantDevicesOutlinedIcon from "@material-ui/icons/ImportantDevicesOutlined";
import MotorcycleOutlinedIcon from "@material-ui/icons/MotorcycleOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";

import styles from "./styles.module.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../reducers/userSlice";
import { selectCompany } from "../../reducers/companySlice";
import dateUtils from "../../utils/date";

//import AlarmIcon from "@material-ui/icons/Alarm";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import { userRoleHasAccessToURL } from "../../utils";
import {
  BarChartIcon,
  CartIcon,
  ChatIcon,
  ClockIcon,
  CouponIcon,
  EditStoreIcon,
  EyeIcon,
  HomeIcon,
  PromotionIcon,
  SettingsIcon,
  UsersIcon,
} from "./sideBarIcons";
import classNames from "classnames";
import { ShieldCheckGrayIcon, UtensilsIcon } from "../../assets/icons/svgIcons";
import storage from "../../utils/storage";
export default function ModulesList() {
  const todaysDate = dateUtils.formatDate(new Date());
  const lumarketo = storage.get(true);
  // const [logisticOpen, setLogisticOpen] = useState(false);
  /*   const [recordsOpen, setRecordsOpen] = useState(false);
  const [myAccountOpen, setMyAccountOpen] = useState(false); */
  //const [checkoutOpen, setCheckoutOpen] = useState(false);
  //const [menuOpen, setMenuOpen] = useState(false);
  const user = useSelector(selectUser);
  const company = useSelector(selectCompany);
  const CompanyRoles = lumarketo?.companyRoles?.length
    ? lumarketo.companyRoles
    : company?.roles;

  const userRole = lumarketo?.userRole || user?.role;

  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (path, returnPath = false) => {
    if (location.pathname !== path && !returnPath) {
      navigate(path);
    } else return path;
  };
  const getActive = (path, useSearch = false) => {
    const currentPath = location.pathname.split("/")[1];
    const [targetPath, queryString] = path.split("?");

    if (!useSearch) {
      return currentPath === targetPath.split("/")[1];
    }

    const currentParams = new URLSearchParams(location.search);
    const targetParams = new URLSearchParams(queryString || "");

    for (const [key, value] of targetParams) {
      if (currentParams.get(key) !== value) return false;
    }

    return currentPath === targetPath.split("/")[1];
  };

  return (
    <List style={{ overflowY: "auto" }} dense>
      {/* // INICIO // */}
      <Link
        component={RouterLink}
        to={goTo(routes.HOME.path, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <button
          className={classNames(
            getActive(routes.HOME.path)
              ? styles.activeButtonsideBar
              : styles.sideBarMenuBtn
          )}
          type="button"
          disabled={company?._id === undefined}
        >
          <HomeIcon
            color={getActive(routes.HOME.path) ? "#155DFC" : "#6A7282"}
          />
          <span className={styles.linkSideBar}>{routes.HOME.title}</span>
        </button>
      </Link>
      {/* // GESTION // */}
      <h6 className={styles.label}>Gestión</h6>
      <div className={styles.blockMenuContainer}>
        {/* // USERS // */}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "usuarios") ? (
          <Link
            component={RouterLink}
            to={goTo(routes.USERS.path, true)}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(routes.USERS.path)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              disabled={company._id === undefined}
            >
              <UsersIcon
                color={getActive(routes.USERS.path) ? "#155DFC" : "#6A7282"}
              />

              <span className={styles.linkSideBar}>{routes.USERS.title}</span>
            </button>
          </Link>
        ) : null}

        {/* // PRODUCTOS // */}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "almacen") ? (
          <Link
            component={RouterLink}
            to={goTo(`${routes.DEPOSIT.path}?productos`, true)}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(routes.DEPOSIT.path)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              disabled={company._id === undefined}
            >
              <UtensilsIcon
                color={getActive(routes.DEPOSIT.path) ? "#155DFC" : "#6A7282"}
                strokeWidth={1.9}
                height={16}
                width={16}
              />

              <span className={styles.linkSideBar}>{routes.DEPOSIT.title}</span>
            </button>
          </Link>
        ) : null}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "pedidos") ? (
          <Link
            component={RouterLink}
            to={goTo(`${routes.ORDERS.path}?paraHoy`, true)}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(`${routes.ORDERS.path}`)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              disabled={company._id === undefined}
            >
              <CartIcon
                color={
                  getActive(`${routes.ORDERS.path}`) ? "#155DFC" : "#6A7282"
                }
              />
              <span className={styles.linkSideBar}>{routes.ORDERS.title}</span>
            </button>
          </Link>
        ) : null}
        {/*   {userRoleHasAccessToURL(CompanyRoles, userRole, "mis-envios") ? (
          <Link
            component={RouterLink}
            to={goTo(`${routes.MYSHIPMENT.path}`)}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(`${routes.MYSHIPMENT.path}`)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              disabled={company._id === undefined}
            >
              <ShieldCheckGrayIcon
                color={
                  getActive(`${routes.MYSHIPMENT.path}`) ? "#155DFC" : "#6A7282"
                }
              />
              <span className={styles.linkSideBar}>
                {routes.MYSHIPMENT.title}
              </span>
            </button>
          </Link>
        ) : null} */}
        <Link
          component={RouterLink}
          to={goTo(routes.MYSHIPMENT.path, true)}
          style={{
            textDecoration: "none",
          }}
        >
          <button
            className={classNames(
              getActive(routes.MYSHIPMENT.path)
                ? styles.activeButtonsideBar
                : styles.sideBarMenuBtn
            )}
            type="button"
            disabled={company._id === undefined}
            onClick={() => goTo(routes.MYSHIPMENT.path, true)}
          >
            <ShieldCheckGrayIcon
              color={
                getActive(`${routes.MYSHIPMENT.path}`) ? "#155DFC" : "#6A7282"
              }
            />
            <span className={styles.linkSideBar}>
              {routes.MYSHIPMENT.title}
            </span>
          </button>
        </Link>

        {userRoleHasAccessToURL(CompanyRoles, userRole, "sucursales") ? (
          <Link
            component={RouterLink}
            to={goTo(routes.SUBSIDIARIES.path, true)}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(routes.SUBSIDIARIES.path)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              onClick={() => goTo(routes.SUBSIDIARIES.path)}
            >
              <ClockIcon
                color={
                  getActive(routes.SUBSIDIARIES.path) ? "#155DFC" : "#6A7282"
                }
              />
              <span className={styles.linkSideBar}>
                {routes.SUBSIDIARIES.title}
              </span>
            </button>
          </Link>
        ) : null}

        {/* // RESERVAS // */}
        {/*   <Link
        component={RouterLink}
        to={goTo(routes.BOOKINGS.path, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem button onClick={() => goTo(routes.BOOKINGS.path)}>
          <ListItemIcon>
            <Icon>
              <AlarmIcon style={{ color: "#364153" , width: 16 }} />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={
              <h6
                className={
                  getActive(routes.BOOKINGS.path)
                    ? `${styles.linkSideBar} ${styles.activeLabel}`
                    : styles.linkSideBar
                }
              >
                {routes.BOOKINGS.title}
              </h6>
            }
          />
        </ListItem>
      </Link> */}
        {/*  Reportes */}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "ventas") ? (
          <Link
            component={RouterLink}
            to={goTo(
              routes.SALES.path +
                `?startDate=${todaysDate}&endDate=${todaysDate}`,
              true
            )}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(routes.SALES.path)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              disabled={company?._id === undefined}
            >
              <BarChartIcon
                color={getActive(routes.SALES.path) ? "#155DFC" : "#6A7282"}
              />

              <span className={styles.linkSideBar}>Reportes</span>
            </button>
          </Link>
        ) : null}
        {userRoleHasAccessToURL(
          CompanyRoles,
          userRole,
          "configuraciones-de-la-tienda"
        ) ? (
          <Link
            component={RouterLink}
            to={goTo(`${routes.STORE_SETTINGS.path}`, true)}
            style={{
              textDecoration: "none",
            }}
          >
            <button
              className={classNames(
                getActive(routes.STORE_SETTINGS.path)
                  ? styles.activeButtonsideBar
                  : styles.sideBarMenuBtn
              )}
              type="button"
              disabled={company._id === undefined}
            >
              <SettingsIcon
                color={
                  getActive(routes.STORE_SETTINGS.path) ? "#155DFC" : "#6A7282"
                }
              />

              <span className={styles.linkSideBar}>Configuraciones</span>
            </button>
          </Link>
        ) : null}
        {/* // MENUS // */}
        {/*   <ListItem button onClick={() => setMenuOpen(!menuOpen)}>
        <ListItemIcon>
          <Icon>
            <img
              className={cssStyles.tabIcon}
              src={SideBarIcons.Ordenes}
              alt="menus"
              width={16}
              height={13}
            />
          </Icon>
        </ListItemIcon>
        <ListItemText primary={<h6 className={styles.linkSideBar}>Menus</h6>} />
        {menuOpen ? (
          <ExpandLess style={{ color: "#364153"  }} />
        ) : (
          <ExpandMore style={{ color: "#364153"  }} />
        )}
      </ListItem>

      <Collapse in={menuOpen} timeout="auto" unmountOnExit>
        <MuiThemeProvider theme={subListTheme}>
          <List component="div" disablePadding>
            <Link
              component={RouterLink}
              to={goTo(`${routes.MODULE_WEB.path}`, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.nested}
                button
                // onClick={() => goTo(routes.ORDERS.path)}
                disabled={
                  user && user.role && userConstants.ROLES.PICKER === user.role
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(`${routes.MODULE_WEB.path}`)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      Página de inicio
                    </h6>
                  }
                />
              </ListItem>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(`${routes.MODULE_WEB.path}?page=menuqr`, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.nested}
                button
                // onClick={() => goTo(routes.ORDERS.path)}
                disabled={
                  user && user.role && userConstants.ROLES.PICKER === user.role
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(`${routes.MODULE_WEB.path}?page=menuqr`)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      Página QR
                    </h6>
                  }
                />
              </ListItem>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(routes.MENU.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.nested}
                button
                // onClick={() => goTo(routes.ORDERS.path)}
                disabled={
                  user && user.role && userConstants.ROLES.PICKER === user.role
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(routes.MENU.path)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      Ver mis QRs
                    </h6>
                  }
                />
              </ListItem>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(`${routes.QR_SURVEY.path}`, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.nested}
                button
                // onClick={() => goTo(routes.ORDERS.path)}
                disabled={
                  user && user.role && userConstants.ROLES.PICKER === user.role
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(`${routes.QR_SURVEY.path}`)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      Encuesta QR
                    </h6>
                  }
                />
              </ListItem>
            </Link>
          </List>
        </MuiThemeProvider>
      </Collapse> */}
      </div>
      <div className={styles.blockMenuContainer}>
        {/* // Soporte al cliente //  */}

        {userRoleHasAccessToURL(
          CompanyRoles,
          userRole,
          "soporte-al-cliente"
        ) ? (
          <>
            <h6 className={styles.label}>Soporte al cliente</h6>
            <Link
              component={RouterLink}
              to={goTo(routes.CUSTOMER_SERVICE.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(routes.CUSTOMER_SERVICE.path)
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                disabled={company._id === undefined}
              >
                <ChatIcon
                  color={
                    getActive(routes.CUSTOMER_SERVICE.path)
                      ? "#155DFC"
                      : "#6A7282"
                  }
                />

                <span className={styles.linkSideBar}>Mensajes</span>
              </button>
            </Link>
          </>
        ) : null}
      </div>{" "}
      <div className={styles.blockMenuContainer}>
        {/* //INTEGRACIONES //  */}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "integraciones") ? (
          <>
            <h6 className={styles.label}>INTEGRACIONES</h6>
            <Link
              component={RouterLink}
              to={goTo(`${routes.INTEGRATIONS_NATIVE.path}?category=POS`, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=POS`,
                    true
                  )
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() =>
                  goTo(`${routes.INTEGRATIONS_NATIVE.path}?category=POS`)
                }
                disabled={company._id === undefined}
              >
                <ImportantDevicesOutlinedIcon
                  style={{
                    color: getActive(
                      `${routes.INTEGRATIONS_NATIVE.path}?category=POS`,
                      true
                    )
                      ? "#155DFC"
                      : "#6A7282",
                  }}
                  className={styles.iconElement}
                />

                <span className={styles.linkSideBar}>POS</span>
              </button>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(
                `${routes.INTEGRATIONS_NATIVE.path}?category=Pagos`,
                true
              )}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=Pagos`,
                    true
                  )
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() =>
                  goTo(`${routes.INTEGRATIONS_NATIVE.path}?category=Pagos`)
                }
                disabled={company._id === undefined}
              >
                <PaymentOutlinedIcon
                  style={{
                    color: getActive(
                      `${routes.INTEGRATIONS_NATIVE.path}?category=Pagos`,
                      true
                    )
                      ? "#155DFC"
                      : "#6A7282",
                  }}
                  className={styles.iconElement}
                />

                <span className={styles.linkSideBar}>Pasarelas de pago</span>
              </button>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(
                `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío`,
                true
              )}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío`,
                    true
                  ) ||
                    location.pathname ===
                      `${routes.INTEGRATIONS_NATIVE.path}/pedidosya` ||
                    location.pathname ===
                      `${routes.INTEGRATIONS_NATIVE.path}/uber` ||
                    location.pathname ===
                      `${routes.INTEGRATIONS_NATIVE.path}/cabify`
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() =>
                  goTo(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío`
                  )
                }
                disabled={company._id === undefined}
              >
                <MotorcycleOutlinedIcon
                  style={{
                    color:
                      getActive(
                        `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío`,
                        true
                      ) ||
                      location.pathname ===
                        `${routes.INTEGRATIONS_NATIVE.path}/pedidosya` ||
                      location.pathname ===
                        `${routes.INTEGRATIONS_NATIVE.path}/uber` ||
                      location.pathname ===
                        `${routes.INTEGRATIONS_NATIVE.path}/cabify`
                        ? "#155DFC"
                        : "#6A7282",
                  }}
                  className={styles.iconElement}
                />

                <span className={styles.linkSideBar}>Flotas de envío</span>
              </button>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(
                `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío+propio`,
                true
              )}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío+propio`,
                    true
                  )
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() =>
                  goTo(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío+propio`
                  )
                }
                disabled={company._id === undefined}
              >
                <LocalShippingOutlinedIcon
                  style={{
                    color: getActive(
                      `${routes.INTEGRATIONS_NATIVE.path}?category=Flotas+de+envío+propio`,
                      true
                    )
                      ? "#155DFC"
                      : "#6A7282",
                  }}
                  className={styles.iconElement}
                />

                <span className={styles.linkSideBar}>
                  Flotas de envíos propios
                </span>
              </button>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(`${routes.INTEGRATIONS_NATIVE.path}?category=all`, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(
                    `${routes.INTEGRATIONS_NATIVE.path}?category=all`,
                    true
                  )
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() =>
                  goTo(`${routes.INTEGRATIONS_NATIVE.path}?category=all`)
                }
                disabled={company._id === undefined}
              >
                <EyeIcon
                  color={
                    getActive(
                      `${routes.INTEGRATIONS_NATIVE.path}?category=all`,
                      true
                    )
                      ? "#155DFC"
                      : "#6A7282"
                  }
                />

                <span className={styles.linkSideBar}>Ver todos</span>
              </button>
            </Link>
          </>
        ) : null}
      </div>{" "}
      <div className={styles.blockMenuContainer}>
        {/* // Marketing //  */}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "marketing") ? (
          <>
            <h6 className={styles.label}>Marketing</h6>
            <Link
              component={RouterLink}
              to={goTo(routes.COUPON_MARKETING.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  location.pathname === routes.COUPON_MARKETING.path
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                disabled={company._id === undefined}
              >
                <CouponIcon
                  color={
                    location.pathname === routes.COUPON_MARKETING.path
                      ? "#155DFC"
                      : "#6A7282"
                  }
                />

                <span className={styles.linkSideBar}>
                  {routes.COUPON_MARKETING.title}
                </span>
              </button>
            </Link>
            {/*   <Link
        component={RouterLink}
        to={goTo(routes.EMAIL_MARKETING.path, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem
          button
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <MailOutlineIcon
                style={{
                  color: "#364153" ,
                  width: 16,
                  height: "auto",
                }}
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={
              <h6
                className={
                  getActive(routes.EMAIL_MARKETING.path)
                    ? `${styles.linkSideBar} ${styles.activeLabel}`
                    : styles.linkSideBar
                }
              >
                {routes.EMAIL_MARKETING.title}
              </h6>
            }
          />
        </ListItem>
      </Link> */}
            <Link
              component={RouterLink}
              to={goTo(routes.DISCOUNT_MARKETING.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  location.pathname === routes.DISCOUNT_MARKETING.path
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                disabled={company._id === undefined}
              >
                <PromotionIcon
                  color={
                    location.pathname === routes.DISCOUNT_MARKETING.path
                      ? "#155DFC"
                      : "#6A7282"
                  }
                />

                <span className={styles.linkSideBar}>
                  {routes.DISCOUNT_MARKETING.title}
                </span>
              </button>
            </Link>
            {/*  <Link
        component={RouterLink}
        to={goTo(routes.MAILCHIMP_MARKETING.path, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem
          button
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <MailOutlineIcon
                style={{
                  color: "#364153" ,
                  width: 16,
                  height: "auto",
                }}
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={
              <h6
                className={
                  getActive(routes.MAILCHIMP_MARKETING.path)
                    ? `${styles.linkSideBar} ${styles.activeLabel}`
                    : styles.linkSideBar
                }
              >
                {routes.MAILCHIMP_MARKETING.title}
              </h6>
            }
          />
        </ListItem>
      </Link> */}
            {/* // Canales de ventas // */}
            {/*      <h6 className={styles.label}>Canales de ventas</h6>
      <Link
        component={RouterLink}
        to={goTo(routes.FACEBOOK_SHOPPING.base, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem
          button
          onClick={() => goTo(routes.FACEBOOK_SHOPPING.base)}
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <img
                className={cssStyles.tabIcon}
                src={SideBarIcons.FacebookShopping}
                alt="home"
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={
              <h6
                className={
                  getActive(routes.FACEBOOK_SHOPPING.base)
                    ? `${styles.linkSideBar} ${styles.activeLabel}`
                    : styles.linkSideBar
                }
              >
                {routes.FACEBOOK_SHOPPING.title}
              </h6>
            }
          />
        </ListItem>
      </Link>
      <Link
        component={RouterLink}
        to={goTo(routes.INSTAGRAM_SHOPPING.base, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem
          button
          onClick={() => goTo(routes.INSTAGRAM_SHOPPING.base)}
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <img
                className={cssStyles.tabIcon}
                src={SideBarIcons.InstagramShopping}
                alt="home"
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={
              <h6
                className={
                  getActive(routes.INSTAGRAM_SHOPPING.base)
                    ? `${styles.linkSideBar} ${styles.activeLabel}`
                    : styles.linkSideBar
                }
              >
                {routes.INSTAGRAM_SHOPPING.title}
              </h6>
            }
          />
        </ListItem>
      </Link>
      <Link
        component={RouterLink}
        to={goTo(routes.GOOGLE_SHOPPING.path, true)}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem
          button
          onClick={() => goTo(routes.GOOGLE_SHOPPING.path)}
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <img
                className={cssStyles.tabIcon}
                src={SideBarIcons.GoogleShopping}
                alt="home"
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={
              <h6
                className={
                  getActive(routes.GOOGLE_SHOPPING.path)
                    ? `${styles.linkSideBar} ${styles.activeLabel}`
                    : styles.linkSideBar
                }
              >
                {routes.GOOGLE_SHOPPING.title}
              </h6>
            }
          />
        </ListItem>
      </Link> */}{" "}
          </>
        ) : null}
      </div>{" "}
      <div className={styles.blockMenuContainer}>
        {/* // Personalizacion de tienda //  */}
        {userRoleHasAccessToURL(CompanyRoles, userRole, "modulo-web") ? (
          <>
            <h6 className={styles.label}>Personalización de tienda</h6>
            {/* <Link
        component={RouterLink}
        to={goTo(
          `${routes.WEB.path}?c=${webConstants.routes.COLLECTIONS}`,
          true
        )}
        style={{
          textDecoration: "none",
        }}
      >
        <ListItem

          button
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <img
                className={cssStyles.tabIcon}
                src={collectionsIcon}
                alt="home"
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={<h6>Colecciones</h6>}
            className={
              getActive(
                `${routes.WEB.path}?c=${webConstants.routes.COLLECTIONS}`
              )
                ? `${styles.linkSideBar} ${styles.activeLabel}`
                : styles.linkSideBar
            }
          />
        </ListItem>
      </Link> */}

            <Link
              component={RouterLink}
              to={goTo(
                company.UseHome
                  ? routes.MODULE_WEB.path
                  : `${routes.MODULE_WEB.path}?page=pedir`,
                true
              )}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  getActive(
                    company.UseHome
                      ? routes.MODULE_WEB.path
                      : `${routes.MODULE_WEB.path}?page=pedir`
                  )
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                disabled={company._id === undefined}
              >
                <EditStoreIcon
                  color={
                    getActive(
                      company.UseHome
                        ? routes.MODULE_WEB.path
                        : `${routes.MODULE_WEB.path}?page=pedir`
                    )
                      ? "#155DFC"
                      : "#6A7282"
                  }
                />

                <span className={styles.linkSideBar}>Editar página web</span>
              </button>
            </Link>
            {/* <Link
        component={RouterLink}
        to={goTo(
          `${routes.WEB.path}?c=${webConstants.routes.TEMPLATES}`,
          true
        )}
        style={{
          textDecoration: "none",
        }}
      >

        <ListItem
          button
          disabled={
            company._id === undefined 
          }
        >
          <ListItemIcon>
            <Icon>
              <img
                className={cssStyles.tabIcon}
                src={templateIcon}
                alt="home"
              />
            </Icon>
          </ListItemIcon>
          <ListItemText
            primary={<h6>Plantillas</h6>}
            className={
              getActive(
                `${routes.WEB.path}?c=${webConstants.routes.TEMPLATES}`
              )
                ? `${styles.linkSideBar} ${styles.activeLabel}`
                : styles.linkSideBar
            }
          />
        </ListItem>
      </Link> */}
          </>
        ) : null}
      </div>{" "}
      <div className={styles.blockMenuContainer}>
        {userRoleHasAccessToURL(CompanyRoles, userRole, "configuraciones") ? (
          <>
            {/* // Configuraciones // */}
            <h6 className={styles.label}>Mi cuenta</h6>
            {/*   <ListItem button onClick={() => setCheckoutOpen(!checkoutOpen)}>
        <ListItemIcon>
          <ListItemIcon>
            <Icon>
              <img
                className={cssStyles.tabIcon}
                src={SideBarIcons.Checkout}
                alt="home"
              />
            </Icon>
          </ListItemIcon>
        </ListItemIcon>
        <ListItemText primary={<h6 className={styles.linkSideBar}>Checkout</h6>} />
        {checkoutOpen ? (
          <ExpandLess style={{ color: "#364153"  }} />
        ) : (
          <ExpandMore style={{ color: "#364153"  }} />
        )}
      </ListItem> */}
            {/* <Collapse in={checkoutOpen} timeout="auto" unmountOnExit>
        <ListItem
          button
          onClick={() => setLogisticOpen(!logisticOpen)}
          className={classes.nested}
        >
          <ListItemText primary={<h6 className={styles.linkSideBar}>Envíos</h6>} />
          {logisticOpen ? (
            <ExpandLess style={{ color: "#364153"  }} />
          ) : (
            <ExpandMore style={{ color: "#364153"  }} />
          )}
        </ListItem>
        <Collapse in={logisticOpen} timeout="auto" unmountOnExit>
          <MuiThemeProvider theme={subListTheme}>
            <List component="div" disablePadding>
              <Link
                component={RouterLink}
                to={goTo(routes.SHIPPING_PREFERENCE.path, true)}
                style={{
                  textDecoration: "none",
                }}
              >
                <ListItem
                  className={classes.subListNested}
                  button
                  onClick={() => goTo(routes.SHIPPING_PREFERENCE.path)}
                  disabled={
                    company._id === undefined 
                  }
                >
                  <ListItemText
                    primary={
                      <h6
                        className={
                          getActive(routes.SHIPPING_PREFERENCE.path)
                            ? `${styles.linkSideBar} ${styles.activeLabel}`
                            : styles.linkSideBar
                        }
                      >
                        {routes.SHIPPING_PREFERENCE.title}
                      </h6>
                    }
                  />
                </ListItem>
              </Link>
            </List>
          </MuiThemeProvider>
        </Collapse>
        {user && user.role && userConstants.ROLES.ADMIN === user.role && (
          <Link
            component={RouterLink}
            to={goTo(routes.BSALE_SETTINGS.path, true)}
            style={{
              textDecoration: "none",
            }}
          >
            <ListItem
              className={classes.nested}
              button
              onClick={() => goTo(routes.BSALE_SETTINGS.path)}
              disabled={
                company._id === undefined
              }
            >
              <ListItemText
                primary={
                  <h6
                    className={
                      getActive(routes.BSALE_SETTINGS.path)
                        ? `${styles.linkSideBar} ${styles.activeLabel}`
                        : styles.linkSideBar
                    }
                  >
                    {routes.BSALE_SETTINGS.title}
                  </h6>
                }
              />
            </ListItem>
          </Link>
        )}
      </Collapse> */}

            <Link
              component={RouterLink}
              to={goTo(routes.COMPANY_PAYMENTS_SETTINGS.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  location.pathname === routes.COMPANY_PAYMENTS_SETTINGS.path
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() => goTo(routes.COMPANY_PAYMENTS_SETTINGS.path)}
                disabled={company._id === undefined}
              >
                <MonetizationOnOutlinedIcon
                  style={{
                    color:
                      location.pathname ===
                      routes.COMPANY_PAYMENTS_SETTINGS.path
                        ? "#155DFC"
                        : "#6A7282",
                    width: 16,
                    height: 16,
                  }}
                />

                <span className={styles.linkSideBar}>
                  {routes.COMPANY_PAYMENTS_SETTINGS.title}
                </span>
              </button>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(routes.GENERAL_SETTINGS.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  location.pathname === routes.GENERAL_SETTINGS.path
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                onClick={() => goTo(routes.GENERAL_SETTINGS.path)}
                disabled={company._id === undefined}
              >
                <AccountCircleOutlinedIcon
                  style={{
                    color:
                      location.pathname === routes.GENERAL_SETTINGS.path
                        ? "#155DFC"
                        : "#6A7282",
                    width: 16,
                    height: 16,
                  }}
                />

                <span className={styles.linkSideBar}>
                  {routes.GENERAL_SETTINGS.title}
                </span>
              </button>
            </Link>
            {/* <Link
          component={RouterLink}
          to={goTo(routes.PLANS.path, true)}
          style={{
            textDecoration: "none",
          }}
        >
          <ListItem
            button
            onClick={() => goTo(routes.PLANS.path)}
            disabled={
              company._id === undefined 
            }
            className={classes.nested}
          >
            <ListItemText
              primary={
                <h6
                  className={
                    getActive(routes.PLANS.path)
                      ? `${styles.linkSideBar} ${styles.activeLabel}`
                      : styles.linkSideBar
                  }
                >
                  {routes.PLANS.title}
                </h6>
              }
            />
          </ListItem>
        </Link> */}

            <Link
              component={RouterLink}
              to={goTo(routes.PICKERS_SETTINGS.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <button
                className={classNames(
                  location.pathname === routes.PICKERS_SETTINGS.path
                    ? styles.activeButtonsideBar
                    : styles.sideBarMenuBtn
                )}
                type="button"
                disabled={company._id === undefined}
              >
                <GroupOutlinedIcon
                  style={{
                    color:
                      location.pathname === routes.PICKERS_SETTINGS.path
                        ? "#155DFC"
                        : "#6A7282",
                    width: 16,
                    height: 16,
                  }}
                />

                <span className={styles.linkSideBar}>
                  {routes.PICKERS_SETTINGS.title}
                </span>
              </button>
            </Link>

            {/*    <ListItem
        button
        onClick={() => setRecordsOpen(!recordsOpen)}
        className={classes.nested}
      >
        <ListItemText primary={<h6 className={styles.linkSideBar}>Registros </h6>} />
        {recordsOpen ? (
          <ExpandLess style={{ color: "#364153"  }} />
        ) : (
          <ExpandMore style={{ color: "#364153"  }} />
        )}
      </ListItem>
      <Collapse in={recordsOpen} timeout="auto" unmountOnExit>
        <MuiThemeProvider theme={subListTheme}>
          <List component="div" disablePadding>
            <Link
              component={RouterLink}
              to={goTo(routes.DEPOSIT_CHANGES.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.subListNested}
                button
                // onClick={() => goTo(routes.DEPOSIT_CHANGES.path)}
                disabled={
                  company._id === undefined 
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(routes.DEPOSIT_CHANGES.path)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      {routes.DEPOSIT_CHANGES.title}
                    </h6>
                  }
                />
              </ListItem>
            </Link>
            <Link
              component={RouterLink}
              to={goTo(routes.SETTINGS_CHANGES.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.subListNested}
                button
                // onClick={() => goTo(routes.SETTINGS_CHANGES.path)}
                disabled={
                  company._id === undefined
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(routes.SETTINGS_CHANGES.path)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      {routes.SETTINGS_CHANGES.title}
                    </h6>
                  }
                />
              </ListItem>
            </Link>

            <Link
              component={RouterLink}
              to={goTo(routes.ORDERS_CHANGES.path, true)}
              style={{
                textDecoration: "none",
              }}
            >
              <ListItem
                className={classes.subListNested}
                button
                // onClick={() => goTo(routes.ORDERS_CHANGES.path)}
                disabled={
                  company._id === undefined 
                }
              >
                <ListItemText
                  primary={
                    <h6
                      className={
                        getActive(routes.ORDERS_CHANGES.path)
                          ? `${styles.linkSideBar} ${styles.activeLabel}`
                          : styles.linkSideBar
                      }
                    >
                      {routes.ORDERS_CHANGES.title}
                    </h6>
                  }
                />
              </ListItem>
            </Link>
          </List>
        </MuiThemeProvider>
      </Collapse> */}

            {company.UseEmailConfig && (
              <Link
                component={RouterLink}
                to={goTo(routes.EMAIL_SETTINGS.path, true)}
                style={{
                  textDecoration: "none",
                }}
              >
                <button
                  className={classNames(
                    getActive(routes.EMAIL_SETTINGS.path)
                      ? styles.activeButtonsideBar
                      : styles.sideBarMenuBtn
                  )}
                  type="button"
                  onClick={() => goTo(routes.EMAIL_SETTINGS.path)}
                  disabled={company._id === undefined}
                >
                  <span className={styles.linkSideBar}>
                    {routes.EMAIL_SETTINGS.title}
                  </span>
                </button>
              </Link>
            )}
          </>
        ) : null}
      </div>
    </List>
  );
}
